<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

import { usePublicData } from '@/stores/PublicData'

import EditorSettings from '@/components/editor/EditorSettings.vue'
import EditorSettingsGoals from '@/components/editor/EditorSettingsGoals.vue'
import EditorSettingsAchievements from '@/components/editor/EditorSettingsAchievements.vue'
import { LANGUAGES, type LanguageType } from '@/api/interfaces'

const { t } = useTranslate('local')
const store = usePublicData()

const defaultItems = [
  {
    title: t.value('EditorGoalsAchievementsSettings.goals.title'),
    description: t.value('EditorGoalsAchievementsSettings.goals.description'),
    component: EditorSettingsGoals,
  },
  {
    title: t.value('EditorGoalsAchievementsSettings.achievements.title'),
    description: t.value('EditorGoalsAchievementsSettings.achievements.description'),
    component: EditorSettingsAchievements,
  },
]

const items = LANGUAGES.reduce(
  (acc, lang) => {
    acc[lang] = [...defaultItems]
    return acc
  },
  {} as Record<LanguageType, typeof defaultItems>,
)
</script>

<template>
  <EditorSettings :items="items[store.lang]" :title="t('EditorGoalsAchievementsSettings.title')" />
</template>

<style lang="scss" scoped></style>
